import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import InsuranceTile from 'src/components/BuyPolicy/insuranceScreens/health/InsuranceTile'
import CheckImg from 'src/assets/Buy_Policy_Images/WalletPayment.svg'

export const useStyles = makeStyles({
  valueContainerMain: {
    display: 'flex',
    flexDirection: 'column',
    margin: '20px 0',
  },
  valueContainer: {
    border: 'solid #8ED6C9',
    borderRadius: '5px 5px 0px 0px',
    background: 'linear-gradient(180deg, #8ED6C9 -100%, #FFFFFF 102.47%)',
    marginLeft: '2%',
    width: '110px',
    height: '25px',
    textAlign: 'center',
    borderWidth: '1px 1px 0px 1px',
  },
  insuranceTileContainer: {
    zIndex: 1,
  },
  valueContainerText: {
    color: '#3B7D72',
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: 600,
    lineHeight: '13px',
    letterSpacing: '0.02em',
    padding: 5,
  },
  qualityContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    gap: 14,
  },
  qualityContainerLogo: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 5,
    borderBottom: '1px solid #8ED6C9',
    borderLeft: '1px solid #8ED6C9',
    borderRight: '1px solid #8ED6C9',
    borderRadius: '0px 0px 15px 15px',
    background: '#FFFFFF',
    width: 'fit-content',
    padding: '5px 40px 5px 40px',
    marginLeft: '2%',
  },
  qualityContainerText: {
    fontFamily: 'Roboto',
    fontSize: '11px',
    fontWeight: 600,
    lineHeight: '12.89px',
    letterSpacing: '0.02em',
    color: '#3B7D72',
  },
})

const InsuranceTileValue = ({ insuranceDetails }) => {
  const classes = useStyles()

  return (
    <div className={classes.valueContainerMain}>
      <div className={classes.valueContainer}>
        <span className={classes.valueContainerText}>ValueSure</span>
      </div>

      <div className={classes.insuranceTileContainer}>
        <InsuranceTile insuranceDetails={insuranceDetails} />
      </div>

      <div className={classes.qualityContainer}>
        <div className={classes.qualityContainerLogo}>
          <div>
            <img src={CheckImg} alt='valueSure-img'></img>
          </div>

          <div className={classes.qualityContainerText}>
            Unmatched Protection for Your Peace of Mind
          </div>
        </div>
      </div>
    </div>
  )
}

export default InsuranceTileValue
